import React, { useState } from "react";
import { useSpaceConfigurationsConfig } from "../data/spaceconfigurationsconfig-hooks";
import SpaceConfiguration from "./SpaceConfiguration";

function SpaceConfigurations() {
    const { spaceConfigurationsConfig, addSpaceConfiguration } = useSpaceConfigurationsConfig();
    const [isActiveOnly, setIsActiveOnly] = useState(true);

    const isActiveCheckbox = document.getElementById("chkSpaceConfigurationsActive");
    if (typeof (isActiveCheckbox) !== "undefined" && isActiveCheckbox != null) {
        isActiveCheckbox.onclick = async function (ev) {
            setIsActiveOnly(isActiveCheckbox.checked);
        };
    }

    const reps = spaceConfigurationsConfig.SpaceConfigurations.filter(function (user) {
        return isActiveOnly === false || user.IsActive === true;
    });
    const addSpaceConfigurationButton = document.getElementById("btnAddSpaceConfiguration");
    addSpaceConfigurationButton.onclick = async function (ev) {
        ev.preventDefault();

        addSpaceConfiguration();
    };
    
    return (
        <table className="datagrid striped table-flexible">
            <thead>
                <tr className="datagridheader">
                    <td>
                        [![Space Configuration]!]
                    </td>
                    <td>
                        [![Description]!]
                    </td>
                    <td>
                        [![Occupancy]!]
                    </td>
                    <td>
                        [![Area]!]
                    </td>
                    <td>
                        [![Active]!]
                    </td>
                    <td>
                        &nbsp;
                    </td>
                </tr>
            </thead>
            <tbody>
            {reps.map((dt) => {
                return (
                    <SpaceConfiguration key={dt.SpaceConfigurationID} Id={dt.SpaceConfigurationID}></SpaceConfiguration>
                );
            })}
            </tbody>
        </table>
    );
}

export default SpaceConfigurations;